import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { closeChurnDetailsModal } from "store/slices/churnDetailsModal";
import { ChurnDetailsModal } from "./ChurnDetailsModal";

const ARCHIVED_MESSAGE = "Company moved to archived";

// The backend attaches the CHURNED tag itself once churn details are submitted
// (ChurnDetailHandler._create_fresh) -- this only supplies the extra toast message.
const getArchivedMessage = async (): Promise<string | undefined> =>
  ARCHIVED_MESSAGE;

// Rendered from GlobalModals (not inside CRM table cells) so a table re-render, which
// remounts every cell, can't unmount the modal mid-way through filling the form.
export const ChurnDetailsModalHost = () => {
  const dispatch = useAppDispatch();
  const groupId = useAppSelector((state) => state.churnDetailsModal.groupId);

  const handleClose = () => dispatch(closeChurnDetailsModal());

  if (!groupId) {
    return null;
  }

  return (
    <ChurnDetailsModal
      isOpen
      close={handleClose}
      groupId={groupId}
      onChurnConfirmed={getArchivedMessage}
    />
  );
};
